module.exports = __webpack_public_path__ + "static/img/t1.304bbb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/precision/t1.png
// module id = yEYo
// module chunks = 0